<div class="app-airdrop-credit-score" [ngClass]="httpService.theme">
    <div class="d-flex justify-content-between align-items-center mb-3">
        <div class="font_lg bold d-flex gap-2">
            <span>
                {{ task.title }}
            </span>
            <span *ngIf="task.icon">
                <img width="20" [src]="task.icon" alt="" />
            </span>
        </div>

        <div
            [ngClass]="{pending: task.status === 'Pending', in_progress: task.status === 'In Progress', completed: task.status === 'Completed', coming_soon: task.coming_soon}">
            {{ task.status }}
        </div>
    </div>

    <div class="desc_color mb-3" style="text-align: left; width: 75%">
        {{ task.desc }}
    </div>

    <div class="d-flex">
        <cf-button [theme]="httpService.theme" [label]="task.cta" (clicked)="shareCreditScore()" *ngIf="credit_score">
        </cf-button>

        <cf-button [theme]="httpService.theme" label="Generate Credit Score" (clicked)="generateCreditScore()"
            *ngIf="!credit_score" [loading]="generate_credit_score_loading"></cf-button>
    </div>
</div>